import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ParticipantListModel } from '../../../../../shared/models/ParticipantListModel';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { jsPDF } from 'jspdf';
import { ToastrService } from 'ngx-toastr';
import { EnrollEventModelToDownload, MSMEGetEventDetailsForDownload } from '../../../../../shared/models/MSMEGetEventDetailsForDownload';


import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-downloadticket',
  templateUrl: './downloadticket.component.html',
  styleUrl: './downloadticket.component.css'
})
export class DownloadticketComponent implements OnInit {

  eventId = sessionStorage.getItem("EventId");
  udyamNumber = sessionStorage.getItem("udyamNumber");
  shortEventName = sessionStorage.getItem("shortEventName");
  uniqueEventId = sessionStorage.getItem("uniqueEventId");
  /* iaeventID = sessionStorage.getItem("SantComp_CapBul_46");*/
  iaeventID = sessionStorage.getItem("EventId");
  onSpotUserId = sessionStorage.getItem("onSpotUserId");
  //iaeventID = 'SantComp_SkilDev_63';
  eventObj: MSMEGetEventDetailsForDownload | undefined;
  participantObj!: ParticipantListModel;
  msmeUserId = sessionStorage.getItem('msMeUserId');
  iaUserId = sessionStorage.getItem('iaUserId');
  msmeUserName = sessionStorage.getItem('msMeUserName');
  RegistrationId = sessionStorage.getItem('RegistrationId');
  userType = sessionStorage.getItem('UserType');
  participants: any[] = [];
  msmeCertificate: any;

  eventDetails!: EnrollEventModelToDownload;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private toastrService: ToastrService) {
  }
  DtoPagination = {
    UserId: '',
    EventId: '',
    PageNumber: 1,
    PageSize: 10,
    SortColumn: '',
    SortDirection: '',
    SearchTerm: '',
    SearchCol: ''
  };



//  ngOnInit(): void {
//    if (this.eventId && this.userType == 'MSME') {
//      this.LoadDetails(this.eventId);
//      this.LoadParticipantsDetails();
//    }
//    else if (this.iaeventID && this.userType == 'IA') {

//      this.LoadDetails(this.iaeventID);
//      //console.log("iA EVENT", this.iaeventID);
//      //console.log("registration id", this.RegistrationId);
//      this.LoadOnSpotParticipantsDetails();
//    } else {
//      this.toastrService.error("EventId is null. Cannot load details.");
//    }

//    this.route.queryParams.subscribe((params: { [key: string]: string }) => {
//      console.log("Received Query Params:", params);
//    });


//    // Store values in DtoPagination
//    this.DtoPagination = {
//      UserId: params['UserId'],
//      EventId: params['EventId'],
//      PageNumber: +params['PageNumber'] || 1, // Convert to number
//      PageSize: +params['PageSize'] || 10,
//      SortColumn: params['SortColumn'] || '',
//      SortDirection: params['SortDirection'] || '',
//      SearchTerm: params['SearchTerm'] || '',
//      SearchCol: params['SearchCol'] || ''
//    };
//  });

//  
//}


  ngOnInit(): void {
    
    if (this.eventId && this.userType == 'MSME') {
      this.LoadDetails(this.eventId);
      this.LoadParticipantsDetails();
    }
    else if (this.iaeventID && this.userType == 'IA') {
      this.eventId = sessionStorage.getItem("EventId"); // Default eventId
      this.shortEventName = sessionStorage.getItem("shortEventName");
      this.udyamNumber = sessionStorage.getItem("udyamNumber");

      //console.log("eventId1", this.shortEventName)
      //console.log("EventId")
      this.LoadDetails(this.iaeventID);
      this.LoadOnSpotParticipantsDetails();
    } else {
      this.toastrService.error("EventId is null. Cannot load details.");
    }

    // Subscribe to query parameters
    this.route.queryParams.subscribe((params: { [key: string]: string }) => {
      //console.log("Received Query Params:", params);

      // Store values in DtoPagination inside the subscribe function
      this.DtoPagination = {
        UserId: params['UserId'] || '',
        EventId: params['EventId'] || '',
        PageNumber: +params['PageNumber'] || 1, // Convert to number
        PageSize: +params['PageSize'] || 10,
        SortColumn: params['SortColumn'] || '',
        SortDirection: params['SortDirection'] || '',
        SearchTerm: params['SearchTerm'] || '',
        SearchCol: params['SearchCol'] || ''
      };
    });

  
  }

  LoadDetails(EventId: string) {
    if (this.eventId && this.userType == 'MSME') {
      this.apiService.getRequest(API_ENDPOINTS.MSME.GETEVENTFORDOWNLOAD, {
        EventId: EventId,
        UniqueEventId: ''
      }).subscribe(
        (result: MSMEGetEventDetailsForDownload) => {
          if (result.status) {
            this.eventObj = {
              status: result.status,
              message: result.message,
              data: result.data
            };
          } else {
            this.toastrService.error('Failed to load Event details:', result.message);
          }
        },
        error => {
          this.toastrService.error('API Error:', error);
          //console.error('API Error:', error);
        }
      );
    }
    else if (this.iaeventID && this.userType == 'IA') {
      this.apiService.getRequest(API_ENDPOINTS.MSME.GETEVENTFORDOWNLOAD, {
        EventId: '',
        UniqueEventId: this.iaeventID
      }).subscribe(
        (result: MSMEGetEventDetailsForDownload) => {
          if (result.status) {
            this.eventObj = {
              status: result.status,
              message: result.message,
              data: result.data
            };
          } else {
            this.toastrService.error('Failed to load Event details:', result.message);
          }
        },
        error => {
          this.toastrService.error('API Error:', error);
          //console.error('API Error:', error);
        }
      );
    }
    const dtoEvent = {
      EventId: EventId,
      UniqueEventId : ''
    }

   
  }

  LoadParticipantsDetails() {
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETENROLLEDPARTICIPANTLIST, {
      
      EventId: this.eventId,
      MsMeUserId: this.msmeUserId
    }).subscribe(
      (result: ParticipantListModel) => {
        if (result.status) {
          this.participantObj = {
            status: result.status,
            message: result.message,
            data: result.data
          };
        } else {
          this.toastrService.error('Failed to load participants details:', result.message);
          //console.error('Failed to load participants details:', result.message);
        }
      },
      error => {
        this.toastrService.error('API Error:', error);
        //console.error('API Error:', error);
      }
    );
  }

  LoadOnSpotParticipantsDetails() {
    this.apiService.getRequest(API_ENDPOINTS.IA.GETONSPOTENROLLEDPARTICIPANTLIST, {
      uniqueEventId: this.uniqueEventId,
      onSpotUserId: this.onSpotUserId
      //RegistrationId:  'Digital Woods_00086'
    }).subscribe(
      (result: ParticipantListModel) => {
        if (result.status) {
          this.participantObj = {
            status: result.status,
            message: result.message,
            data: result.data
          };
        } else {
          this.toastrService.error('Failed to load participants details:', result.message);
          //console.error('Failed to load participants details:', result.message);
        }
      },
      error => {
        this.toastrService.error('API Error:', error);
        //console.error('API Error:', error);
      }
    );
  } 

  /*
Added by sayali
  */
  //downloadPDF() {
  //  const doc = new jsPDF({
  //    orientation: 'landscape', // Set page orientation to landscape
  //    unit: 'mm', // Use millimeters for measurement
  //    format: 'a4', // Standard A4 size
  //  });

  //  const content = document.querySelector('.pdf-container') as HTMLElement;


  //  // Logo image configurations
  //  const logoImageUrl = 'assets/Images/logo_icon.png'; // First logo image path
  //  const logoImageUrl2 = 'assets/Images/RAMP_LOGO.jpg'; // Second logo image path

  //  // Logo image configurations
  //  const imgWidth = 30;
  //  const imgHeight = 30;
  //  const imgX = 10;
  //  const imgY = 10;
  //  const imgX2 = 250; // Position second logo on the right
  //  const imgY2 = 10;

  //  const logoImage = new Image();
  //  logoImage.src = logoImageUrl;
  //  const logoImage2 = new Image();
  //  logoImage2.src = logoImageUrl2;

  //  // Load both images
  //  Promise.all([
  //    new Promise<void>((resolve) => (logoImage.onload = () => resolve())),
  //    new Promise<void>((resolve) => (logoImage2.onload = () => resolve())),
  //  ]).then(() => {
  //    // Add logo images to the PDF
  //    doc.addImage(logoImage, 'PNG', imgX, imgY, imgWidth, imgHeight);
  //    doc.addImage(logoImage2, 'PNG', imgX2, imgY2, imgWidth, imgHeight);

  //    // Set global font and smaller size
  //    doc.setFont('helvetica');
  //    doc.setFontSize(3); // Reduce font size to fit more content

  //    // If content exists
  //    if (content) {
  //      // Extract dimensions
  //      const contentWidth = 280; // Set a width to avoid overflow (280mm for landscape A4)
  //      const windowWidth = content.scrollWidth || 1000; // Default window width for scaling

  //      // Ensure correct rendering
  //      doc.html(content, {
  //        callback: (doc) => {
  //          doc.save('Acknowledgment Ticket.pdf');
  //        },
  //        margin: [3, 3, 3, 3], // Reduced margins for more space
  //        html2canvas: {
  //          scale: 0.4, // Reduced scale to fit content properly
  //          letterRendering: true,
  //          logging: false,
  //          useCORS: true, // Ensure CORS is enabled if images are loaded from external sources
  //        },
  //        autoPaging: 'text', // Automatically handle text overflow with page breaks
  //        x: 10,
  //        y: imgY + imgHeight + 10, // Start below the logo images
  //        width: contentWidth,
  //        windowWidth: windowWidth,
  //      });
  //    }
  //  });
  //}


  loadPDF() {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });
    
    doc.save('Certificate.pdf');
  }

  convertHtmlToPdf(htmlContent: string) {
    const pdf = new jsPDF({
      orientation: 'landscape', // Use 'landscape' if required
      unit: 'mm',
      format: 'a4',
    });
    
    // Create a hidden div to render HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    tempDiv.style.width = '100%'; // Approx. A4 width in pixels
    tempDiv.style.padding = '20px'; // Add padding for better capture
    tempDiv.style.background = '#13eff6'; // Ensure white background
    document.body.appendChild(tempDiv);

    setTimeout(() => {
      html2canvas(tempDiv, { scale: 2 }).then(canvas => {
        const imgData = canvas.toDataURL('image/png');

        const imgWidth = 210; // A4 width in mm
        const pageHeight = 297; // A4 height in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = 0;

        // Add first page
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        // Add extra pages if content overflows
        while (heightLeft > 0) {
          position -= pageHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        pdf.save('MSME_Certificate.pdf');
        document.body.removeChild(tempDiv); // Clean up temp div
      });
    }, 500); // Small delay ensures content is rendered correctly
  }

  downloadPDF() {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });

    // **Page Border**
    const margin = 10;
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    doc.setDrawColor(0);
    doc.setLineWidth(1);
    doc.rect(margin, margin, pageWidth - 2 * margin, pageHeight - 2 * margin);

    // **Logos**
    const logo1 = 'assets/Images/RAMP_LOGO.jpg';
    const logo2 = 'assets/Images/logo_icon.png';
    const imgWidth = 30, imgHeight = 30, imgX1 = 15, imgX2 = 250, imgY = 15;
    const logoImg1 = new Image(), logoImg2 = new Image();
    logoImg1.src = logo1, logoImg2.src = logo2;

    Promise.all([
      new Promise<void>((resolve) => (logoImg1.onload = () => resolve())),
      new Promise<void>((resolve) => (logoImg2.onload = () => resolve())),
    ]).then(() => {
      doc.addImage(logoImg1, 'PNG', imgX1, imgY, imgWidth, imgHeight);
      doc.addImage(logoImg2, 'PNG', imgX2, imgY, imgWidth, imgHeight);

      // **Title**
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(19);
      doc.setTextColor(197, 41, 42);
      doc.text('Maharashtra Small Scale Industries Development Corporation Ltd.', 148, imgY + 5, { align: 'center' });

      doc.setFontSize(11);
      doc.setTextColor(0, 0, 0);
      doc.text('A Government Of Maharashtra Undertaking', 148, imgY + 12, { align: 'center' });

      doc.setFontSize(10);
      doc.text('CIN No. U74999MH1962SGC012501', 148, imgY + 18, { align: 'center' });

      // **Header Line**
      const lineY = imgY + imgHeight + 5;
      doc.setDrawColor(0);
      doc.line(margin + 5, lineY, pageWidth - margin - 5, lineY);

      // **Acknowledgment Title**
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(19);
      doc.setTextColor(0, 86, 179);
      doc.text('Acknowledgment Ticket', 148, lineY + 10, { align: 'center' });

      // **Event Details**
      let startY = lineY + 18;
      doc.setFontSize(16);
      doc.setTextColor(255, 0, 0);
      doc.text('Event Details', 148, startY, { align: 'center' });

      doc.setFontSize(11);
      doc.setTextColor(0, 0, 0);
      doc.setFont('helvetica', 'normal');

      // Extract event details
      let eventDate = this.eventObj?.data?.[0]?.eventDate?.split(' ')[0] || 'N/A';
      let eventTime = this.eventObj?.data?.[0]?.time || 'N/A';
      let duration = this.eventObj?.data?.[0]?.eventDuration ? `${this.eventObj?.data?.[0]?.eventDuration}` : 'N/A';
      let period = this.eventObj?.data?.[0]?.period || 'N/A';

      // Determine correct Event ID value 
      let eventIdToUse = this.userType === 'IA' ? this.shortEventName : this.eventId;
      let udyamNumber = this.userType === 'IA' ? (this.udyamNumber || 'N/A') : (this.msmeUserName || 'N/A');

      let eventDetails = [
        [{ text: 'Event ID:', bold: true }, { text: eventIdToUse || 'N/A', colspan: 3 }],
       // [{ text: 'Event ID:', bold: true }, { text: this.eventId || 'N/A', colspan: 3 }],
        [{ text: 'Event Name:', bold: true }, { text: this.eventObj?.data?.[0]?.eventName || 'N/A', colspan: 3 }],
        [{ text: 'Venue:', bold: true }, { text: this.eventObj?.data?.[0]?.venueDetails || 'N/A', colspan: 3 }],
        [{ text: 'Date & Time:', bold: true }, { text: `${eventDate}, ${eventTime}`, colspan: 1 },
        { text: 'Duration:', bold: true }, { text: `${duration} ${period}`, colspan: 1 }],
        [{ text: 'Organized By:', bold: true }, { text: this.eventObj?.data?.[0]?.nameOfOrganisation || 'N/A', colspan: 1 },
          { text: 'Udyam Number:', bold: true }, { text: udyamNumber || 'N/A', colspan: 1 }]
      ];

      let colWidths = [40, 80, 40, 80];
      let rowHeight = 7;
      let startX = 35;
      startY += 10;

      eventDetails.forEach(row => {
        let xPos = startX;
        row.forEach(cell => {
          doc.setFont(cell.bold ? 'helvetica' : 'normal', cell.bold ? 'bold' : 'normal');
          doc.text(cell.text, xPos, startY);
          xPos += colWidths[row.indexOf(cell)];
        });
        startY += rowHeight;
      });

      // **Participant List**
      startY += 5;
      doc.setFontSize(13);
      doc.setTextColor(255, 0, 0);
      doc.setFont('helvetica', 'bold');
      doc.text('Participant List', 148, startY, { align: 'center' });

      // **Table Headers**
      const tableHeaders = [['Sr.No', 'Enrollment ID', 'Participant Name', 'Email Id', 'Mobile Number']];
      const tableRows = this.participantObj?.data?.map((p, index) => [
        index + 1, p.enrollmentId, p.participantName, p.emailId, p.mobileNumber
      ]) || [];

      autoTable(doc, {
        head: tableHeaders,
        body: tableRows,
        startY: startY + 5,
        theme: 'grid',
        styles: { fontSize: 10, cellPadding: 2 },
        headStyles: { fillColor: [0, 86, 179], textColor: 255, fontStyle: 'bold' },
        columnStyles: { 0: { cellWidth: 20 }, 1: { cellWidth: 60 }, 2: { cellWidth: 60 }, 3: { cellWidth: 70 }, 4: { cellWidth: 50 } },
        margin: { left: (doc.internal.pageSize.width - 260) / 2 }
      });

      // Save PDF
      doc.save('Acknowledgment_Ticket.pdf');
    });
  }










  sendEmailWithPDF() {
    const emailAddresses = this.participantObj.data.map(p => p.emailId);
    
    this.eventDetails = this.eventObj?.data[0]!;  
    this.participants = this.participantObj.data;
    
    const formData = new FormData();
    formData.append('emails', JSON.stringify(emailAddresses)); 

    Object.keys(this.eventDetails).forEach((key: string) => {
      const value = this.eventDetails[key as keyof EnrollEventModelToDownload];  // Use type assertion here
      formData.append(`eventDetails[${key}]`, value);
    });

   this.participants.forEach((participant, index) => {
    Object.keys(participant).forEach(key => {
      const value = participant[key];
      formData.append(`participants[${index}][${key}]`, value);
    });
  });
  
    this.sendEmailApi(formData);
  }


  sendEmailApi(formData: FormData) {
    this.apiService.postRequest(API_ENDPOINTS.MSME.EMAILTICKETPDF, formData ).subscribe(
      (response: any) => {
        this.toastrService.success('Emails sent successfully');
      },
      (error) => {
        console.error('Error sending email:', error);
        this.toastrService.error('Error sending emails', error);
      }
    );
  } 


  
  onPressBack() {
    const userType = sessionStorage.getItem("UserType");
    const eventId = sessionStorage.getItem("EventId"); // MSME event ID
    const iaEventId = sessionStorage.getItem("iaEventId") || sessionStorage.getItem("EventId"); // IA event ID
    const userId = sessionStorage.getItem("UserId") || sessionStorage.getItem("IAUserId"); // Check both keys

    //console.log("IA Event ID:", iaEventId, "User ID:", userId);

    if (userType === 'MSME' && eventId) {
      this.router.navigate(['/vieweventlist']);
    } else if (userType === 'IA' && iaEventId) {
      this.iaUserId = sessionStorage.getItem('iauserid') ? sessionStorage.getItem('iauserid') : null;
      const eventId = iaEventId;
      this.router.navigate(['/viewallonspotregistration', eventId]
        //, {
        //queryParams: {
        //  UserId: this.iaUserId,
        //  EventId: iaEventId,
        //  PageNumber: 1,
        //  PageSize: 20
        //}
        //}
      );
    } else {
      console.error("Missing required parameters for IA navigation!");
    }
  }





}
